module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[32]31.15fc5c1.woff2";